import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Drawer list for mobile navigation
  const drawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      aria-label="Mobile Navigation"
    >
      <List>
        <ListItem button component={Link} to="/" aria-label="Go to Home page">
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>

        <ListItem
          button
          component={Link}
          to="/about"
          aria-label="Go to About page"
        >
          <ListItemIcon>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary="About" />
        </ListItem>

        <ListItem
          button
          component={Link}
          to="/services"
          aria-label="Go to Services page"
        >
          <ListItemIcon>
            <ContentCutIcon />
          </ListItemIcon>
          <ListItemText primary="Services" />
        </ListItem>

        <ListItem
          button
          component={Link}
          to="/contact"
          aria-label="Go to Contact page"
        >
          <ListItemIcon>
            <ContactPhoneIcon />
          </ListItemIcon>
          <ListItemText primary="Contact" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Semantic AppBar with navigation */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "primary.main",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar component="nav" aria-label="Main Navigation">
          {/* Hamburger Menu for Mobile Screens */}
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="Open menu"
            sx={{ mr: 2, display: { xs: "block", sm: "none" } }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawer(false)}
            sx={{
              "& .MuiDrawer-paper": {
                width: "75vw",
                maxWidth: "300px",
              },
            }}
          >
            {drawerList}
          </Drawer>

          {/* Logo and Brand Name: Linked to Home page */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
              flexGrow: 1,
            }}
            aria-label="Evan Barbers Home"
          >
            <Box
              component="img"
              src="/evanbarbers/logo.webp"
              alt="Evan Barbers Logo"
              sx={{
                marginRight: "10px",
                width: 50,
                height: 50,
                objectFit: "contain",
              }}
            />

            <Typography variant="h6" component="div">
              Evan Barbers
            </Typography>
          </Box>

          {/* Desktop Navigation Links */}
          <Box sx={{ display: { xs: "none", sm: "flex" } }}>
            <Button
              color="inherit"
              component={Link}
              to="/"
              sx={{ ml: 1 }}
              aria-label="Home"
            >
              Home
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/about"
              sx={{ ml: 1 }}
              aria-label="About"
            >
              About
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/services"
              sx={{ ml: 1 }}
              aria-label="Services"
            >
              Services
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/contact"
              sx={{ ml: 1 }}
              aria-label="Contact"
            >
              Contact
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Add spacing so content doesn't hide behind the navbar */}
      <Box sx={{ marginTop: { xs: "58px", sm: "60px" } }} />
    </Box>
  );
};

export default Navbar;
